import React from 'react';
import { css } from '@emotion/core';
import styled from '@emotion/styled';

const disabledStyles = ({ disabled }) => {
  if (disabled) {
    return css`
      pointer-event: none;
      opacity: 0.5;
    `;
  }

  return css``;
};

const Label = styled.label`
  display: block;
  width: 50%;
  padding: 4px;
  padding-left: 0;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;

  input {
    cursor: pointer;
    margin-right: 5px;
    font-size: 12px;
    font-weight: 500;
  }

  ${disabledStyles}
`;

// Inject register into the Field component without having to manually inject into each one
// or using context
export default function makeFieldWithRegister(register) {
  return function Field(props) {
    const {
      label,
      name,
      value,
      disabled = false,
    } = props;

    return (
      <Label disabled={disabled} htmlFor={name}>
        <input
          id={name}
          type="checkbox"
          name={name}
          ref={register}
          value={value}
          disabled={disabled}
        />
        {label}
      </Label>
    );
  };
}
